<template>
  <div class="form-group col-12">
    <label class="col-form-label"> </label>
    <!-- {{broadcastParam}} -->
    <div class="message-bar">
      <div class="message-inner">
        <div class="message-area">
          <div class="input-group">
            <textarea
              :style="'height:300px'"
              ref="messagebox"
              class="form-control"
              v-model="text"
              :placeholder="placeholder"
            ></textarea>
          </div>
          <!-- {{ Math.abs(countdown - 1024) }} -->
          <div v-if="showCountdown">{{ countdown }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 px-0">
      <div class="card border-0">
        <div class="card-body">
          <a-dropdown-button @click="emojiToggle()">
            <img style="width: 15px" src="@/assets/emoji.png" alt />
            <a-menu slot="overlay">
              <a-menu-item
                v-for="temp in templateMessage"
                :key="temp"
                @click="addTemplateToMesage(temp)"
              >
                {{ temp }}
              </a-menu-item>
            </a-menu>
          </a-dropdown-button>
          <a-button-group>
            <a-button @click="applyStyle('*')" style="font-weight: bold"
              >B</a-button
            >
            <a-button @click="applyStyle('_')" style="font-style: italic"
              >I</a-button
            >
            <a-button
              @click="applyStyle('~')"
              style="text-decoration: line-through"
              >s</a-button
            >
            <a-button @click="applyStyle('```')" style="font-family: monospace"
              >MONO</a-button
            > 
          </a-button-group>
          <AIComponent v-model="text" />
          <Emoji
            :open="emojiAttr.open"
            :width="emojiAttr.width"
            :height="emojiAttr.height"
            style="z-index: 9999"
            searchLabel="Search emoji here"
            @click="selectedEmoji"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { VueChatEmoji, emojis } from "vue-chat-emoji";
import { Skeleton } from "vue-loading-skeleton"; 
export default {
  components: {
    Emoji: VueChatEmoji,
    Skeleton: Skeleton,
    AIComponent: () => import("@/components/AIComponent"),
  },
  props: {
    placeholder: {
      type: String,
      default: () => "Type message...",
    },
    showCountdown: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: () => "",
    },
    maxCount: {
      type: Number,
      default: 1024,
    },
  },
  data() {
    return { 
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}",
      ],
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      }, 
    };
  },
  computed: {
    language_style() {
      return this.$store.state.aiKey.language_style;
    },
    countdown() {
      return this.maxCount - this.text.length;
    },
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    showPanel(newVal) {
      if (!newVal) {
        this.recomendation = [];
      }
    },
  },
  mounted() {
    this.$store.dispatch("aiKey/getLanguageStyle");
  },
  methods: {
    checkExist(key) {
      return this.recomendation.some((item) => item.language_style === key);
    },
    addTemplateToMesage(template) {
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      this.text =
        this.text.substring(0, start) + template + this.text.substring(end);
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + template.length;
        textarea.focus();
        const selectStart = start;
        const selectEnd = end + template.length;
        textarea.setSelectionRange(selectStart, selectEnd);
        this.$refs.messagebox.focus();
      });
    },
    applyStyle(symbol) {
      const textarea = this.$refs.messagebox;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const text = this.text;

      this.text =
        text.slice(0, start) +
        symbol +
        text.slice(start, end) +
        symbol +
        text.slice(end);

      // this.showMenu = false;

      this.$nextTick(() => {
        textarea.focus();
        const selectStart = start;
        const selectEnd = end + symbol.length * 2;
        textarea.setSelectionRange(selectStart, selectEnd);
        this.$refs.messagebox.focus();
      });
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      this.text =
        this.text.substring(0, start) + args.emoji + this.text.substring(end);
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + args.emoji.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
      this.emojiToggle(false);
      // console.log(args); /* return {...}*/
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChatComponent/index.vue